import React from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { Button, ButtonGroup } from "aible";
import styles from "./style.module.css";
import CogLight from "images/cog-light.svg";
import { LineInput } from "components/Inputs/LineInput";

import { PROJECT_MODES, PANEL_MODES } from "containers/Run/reducer";
import { INITIAL_BLUEPRINTS } from "containers/Wizard/reducer";

import DatasetViewContainer from "containers/View/Dataset";
import DatasetTile from "components/Tiles/DatasetTile";

import RunItem from "containers/View/Item/RunItem";

import { isEnabled } from "utils/featureFlags";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class ModelGroupHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addGroup: false,
      selectVal: undefined,
      showArrows: true,
      isDataset: false,
      selectedFrontier: undefined
    };
  }

  renderAltFrontierModal() {
    const { altFrontiers, setRunId, runId } = this.props;

    const { selectedFrontier } = this.state;

    return (
      <div id={"altFrontierModal"}>
        <Dialog open={this.state.isAltFrontiers} onOpenChange={() => this.setState({ isAltFrontiers: false })}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{"Select a Frontier"}</DialogTitle>
            </DialogHeader>
            {selectedFrontier === undefined ? (
              <div className={styles.frontierList}>
                {altFrontiers.map((f, i) => (
                  <div className={styles.frontHolder} key={f.job_id + "k" + i}>
                    <div className={styles.badgeHolder}>
                      {f.status === "ACCEPTED" && (
                        <div className={styles.badge} style={{ background: "#5BCF74" }}>
                          {"Approved"}
                        </div>
                      )}
                      {f.job_id === runId ? (
                        <div className={styles.badge}>{"Viewing"}</div>
                      ) : (
                        <div className={styles.hover + " " + styles.badge}>{"Click to View"}</div>
                      )}
                    </div>

                    <RunItem
                      id={f.job_id}
                      isTile
                      onClick={(e) => {
                        setRunId(e);
                        return this.setState({ isAltFrontiers: false });
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.chosenDataset}>
                {"Create new Frontier from this dataset: "}
                <Button onClick={() => this.setState({ selectedFrontier: undefined })}>{"Change Dataset"}</Button>
              </div>
            )}
            <DialogFooter>
              <Button type="secondary" onClick={() => this.setState({ isAltFrontiers: false })}>
                {"Close"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  renderDatasetModal() {
    const { datasets, createRunFromDataset } = this.props;

    const updateDataset =
      datasets &&
      this.state.updateDatasetId !== undefined &&
      datasets.filter((d) => d.id === this.state.updateDatasetId).length > 0
        ? datasets.filter((d) => d.id === this.state.updateDatasetId)[0]
        : undefined;

    return (
      <div id={"datasetModal"}>
        <Dialog open={this.state.isDataset} onOpenChange={() => this.setState({ isDataset: false })}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{"Select a Dataset"}</DialogTitle>
            </DialogHeader>

            {updateDataset === undefined ? (
              <div className={styles.datasetList}>
                <DatasetViewContainer onClick={(d) => this.setState({ updateDatasetId: d })} />
              </div>
            ) : (
              <div className={styles.chosenDataset}>
                {"Create new Frontier from this dataset: "}
                <DatasetTile dataset={updateDataset} />
                <Button onClick={() => this.setState({ updateDatasetId: undefined })}>{"Change Dataset"}</Button>
              </div>
            )}
            <DialogFooter>
              <Button type="secondary" onClick={() => this.setState({ isDataset: false })}>
                {"Close"}
              </Button>
              <Button
                type="primary"
                disabled={this.state.updateDatasetId === undefined}
                onClick={() => {
                  createRunFromDataset(this.state.updateDatasetId);
                  return this.setState({ isDataset: false });
                }}
              >
                {"Create New Frontier"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  render() {
    const {
      runId,
      blueprintId,
      isRunning,
      blueprint,
      isAibleBlueprint,
      updateBlueprint,
      createNewBlueprint,
      setupChanged,
      reloadBlueprint,
      handleCancel,
      initJob,
      models,
      isEditing,
      altFrontiers,
      lockBlueprint,
      updateIsEditing,
      isCreateNewBlueprint,
      isQuickRun,
      mode,
      updatePanelMode,
      panelMode,
      updateMode,
      isBlueprintLocked,
      showPublishBlueprint,
      steps,
      isMarketplace
    } = this.props;

    const { isExport } = this.state;

    const disableEdit = INITIAL_BLUEPRINTS[(blueprintId + "").toUpperCase()] !== undefined && steps.length === 1;

    return (
      <div className={styles.secondHeader + " " + (isEditing ? styles.editingSecond : "")}>
        <div style={{ flexGrow: 1 }} />
        {this.renderDatasetModal()}
        {this.renderAltFrontierModal()}
        <div className={styles.headerActions}>
          {!isEditing && runId !== "new" && (
            <ButtonGroup className={styles.flexButton}>
              <Button
                type="secondary"
                active={mode && mode === PROJECT_MODES.RUN}
                onClick={() => updateMode(PROJECT_MODES.RUN)}
                disabled={isEditing}
              >
                {"Model"}
              </Button>
              {isEnabled("audit") && (
                <Button
                  type="secondary"
                  active={mode && mode === PROJECT_MODES.AUDIT}
                  onClick={() => updateMode(PROJECT_MODES.AUDIT)}
                  disabled={isEditing}
                >
                  {"Audit"}
                </Button>
              )}
            </ButtonGroup>
          )}
          {(blueprintId === "template" || blueprintId === "academic") && runId === "new" ? (
            <div />
          ) : isExport ? (
            <div className={styles.export}>
              <LineInput isMediumBox value={JSON.stringify(blueprint)} style={{ width: "100%" }} focus />
              <Button
                type="secondary"
                onClick={() => this.setState({ isExport: false })}
                className={styles.cancelButton}
              >
                {"Cancel"}
              </Button>
            </div>
          ) : (blueprintId !== "new" || runId !== "new") && isEditing !== true ? (
            isCreateNewBlueprint ? (
              <Button
                type="secondary"
                onClick={() => updateIsEditing(true)}
                className={styles.cancelButton}
                disabled={isBlueprintLocked || disableEdit || mode === PROJECT_MODES.MONITOR}
                title={isBlueprintLocked ? "Cannot edit a locked Blueprint" : "Edit Blueprint"}
                style={{ marginLeft: "20px", marginRight: "10px" }}
              >
                {"Create Blueprint"}
              </Button>
            ) : (
              <DropdownButton
                pullRight
                id="blueprint-dropdown-button"
                title={<img src={CogLight} />}
                style={{
                  width: "50px",
                  margin: "3px 10px 3px 20px"
                }}
                noCaret
              >
                <MenuItem onClick={isBlueprintLocked || disableEdit ? () => {} : () => updateIsEditing(true)}>
                  {isBlueprintLocked ? "Can't Edit Locked Blueprint" : "Edit Blueprint"}
                </MenuItem>
                {blueprint && isEnabled("export-blueprints") && (
                  <MenuItem onClick={() => this.setState({ isExport: true })}>{"Export Blueprint"}</MenuItem>
                )}
                <MenuItem onClick={() => lockBlueprint(!isBlueprintLocked)}>
                  {isBlueprintLocked ? "Unlock Blueprint" : "Lock Blueprint"}
                </MenuItem>
                {altFrontiers && altFrontiers.length > 1 && (
                  <MenuItem onClick={() => this.setState({ isAltFrontiers: true })}>
                    {"View Alternate Frontiers"}
                  </MenuItem>
                )}
                {runId !== "new" && (
                  <MenuItem onClick={() => this.setState({ isDataset: true })}>{"Retrain From New Dataset"}</MenuItem>
                )}
                {runId !== "new" &&
                  isRunning(<MenuItem onClick={() => handleCancel()}>{"Cancel Model Training"}</MenuItem>)}
              </DropdownButton>
            )
          ) : (
            <div className={styles.anotherBHolder}>
              {(blueprintId !== "new" || runId !== "new") && (
                <Button
                  type="secondary"
                  onClick={() => {
                    updateIsEditing(false);
                    blueprintId !== "template" && reloadBlueprint();
                  }}
                  className={styles.cancelButton}
                >
                  {"Close Editor"}
                </Button>
              )}
              <ButtonGroup className={styles.flexButton}>
                {isMarketplace && blueprintId !== "new" && isAibleBlueprint !== true && (
                  <Button type="secondary" onClick={showPublishBlueprint}>
                    {"Publish"}
                  </Button>
                )}
                {blueprintId !== "new" && isAibleBlueprint !== true && (
                  <Button
                    type="secondary"
                    onClick={() => {
                      updateBlueprint();
                      updateIsEditing(false);
                    }}
                  >
                    {"Update Blueprint"}
                  </Button>
                )}
                <Button type="secondary" onClick={() => createNewBlueprint()} className={styles.cancelButton}>
                  {"Save as New Blueprint"}
                </Button>
              </ButtonGroup>
            </div>
          )}
          {setupChanged && !isEditing && runId !== "new" && (
            <Button type="primary" className={styles.newInputsButton} onClick={() => initJob()}>
              {"Run With New Inputs"}
            </Button>
          )}
          {!isEditing && runId !== "new" && (
            <ButtonGroup className={styles.flexButton} style={{ margin: "0px 10px" }}>
              <Button
                type="secondary"
                active={panelMode === PANEL_MODES.SELECTED_MODEL}
                onClick={() =>
                  updatePanelMode(
                    panelMode === PANEL_MODES.SELECTED_MODEL ? PANEL_MODES.CLOSED : PANEL_MODES.SELECTED_MODEL
                  )
                }
                disabled={
                  runId === -1 || models === undefined || models.filter((m) => m.id !== "Current State").length === 0
                }
              >
                {isQuickRun ? "Model Details" : "Adjust Settings"}
              </Button>
            </ButtonGroup>
          )}
        </div>
      </div>
    );
  }
}
